<template>

    <div>
      inputs Placeholder
      <div></div>
      <div></div>
      <div></div>
  </div>

</template>

<script>

export default {
  components: {
  }

}

</script>

<style scoped>
</style>
